import Icon from '../components/Icon.vue'

Icon.register({
  deaf: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216 260C216 275.5 203.5 288 188 288S160 275.5 160 260C160 215.9 195.9 180 240 180S320 215.9 320 260C320 275.5 307.5 288 292 288S264 275.5 264 260C264 246.8 253.2 236 240 236S216 246.8 216 260zM240 84C143 84 64 163 64 260 64 275.5 76.5 288 92 288S120 275.5 120 260C120 193.8 173.8 140 240 140S360 193.8 360 260C360 335.2 289 330.3 288 403.6L288 404C288 432.7 264.7 456 236 456 220.5 456 208 468.5 208 484S220.5 512 236 512C295.5 512 343.9 463.7 344 404.2 344.6 369.8 416 356 416 260 416 163 337 84 240 84zM508.5 31.8L480.2 3.5C475.5-1.2 467.9-1.2 463.2 3.5L376.2 90.5C371.5 95.2 371.5 102.8 376.2 107.5L404.5 135.8C409.2 140.5 416.8 140.5 421.5 135.8L508.5 48.8C513.2 44.1 513.2 36.5 508.5 31.8zM169 314.7C164.3 310.1 156.7 310.1 152 314.7L3.5 463.2C-1.2 467.9-1.2 475.5 3.5 480.2L31.8 508.5C36.5 513.2 44.1 513.2 48.8 508.5L197.3 360C201.9 355.3 201.9 347.7 197.3 343L169 314.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/deaf.js
// module id = yXkg
// module chunks = 144